import { forwardRef } from "react"
import { DomNodes } from "../../../constants"
import {
  PackagedImage,
  PackagedImageProps
} from "../../../components/common/PackagedImage"

export interface ObjectComponentProps extends PackagedImageProps {
  itemId: string
  resourceId: string
  componentNode: DomNodes
  type: string
  width: string
  height: string
  data: string
  children?: JSX.Element | JSX.Element[]
  className?: string
  accessibilityAttr?: { [key: string]: string }
}

export const ObjectComponent = forwardRef<any, ObjectComponentProps>(
  (props, ref) => {
    const { type, data, children, resourceId, className, resolveAlt, ...rest } =
      props

    if (type.includes("image")) {
      // a11y: the <object> inner content is the authored inline alt; when it is empty,
      // PackagedImage falls back to the live Media Library alt via resolveAlt(src).
      const inlineAlt = typeof children === "string" ? children.trim() : ""
      return (
        <PackagedImage
          ref={ref}
          src={data}
          alt={inlineAlt}
          className={className}
          resourceId={resourceId}
          resolveAlt={resolveAlt}
          allowZoom={false}
          {...rest}
        />
      )
    }

    return (
      <div ref={ref} data-src={data} className={className}>
        {children}
      </div>
    )
  }
)
